<template>
  <!-- Content -->
  <div class="container-xxl flex-grow-1 container-p-y">
    <h4 class="fw-bold py-3 mb-4" v-if="userLogged">
      <span>Dashboard</span>
    </h4>
    <div class="fw-bold py-3 mb-4" v-else>
      <h5>Welcome to LAMODA System !!!</h5>
      <h5>Please
        <router-link :to='"/login"'>
          login
        </router-link>
        to use.
      </h5>
    </div>

    <div class="row" v-if="userLogged">
      <div class="col-xxl-12 col-lg-12">
        <div class="card h-100">
          <div class="row row-bordered g-0">
            <div class="col-lg-8">
              <div class="card-header fw-bold d-flex align-items-center justify-content-between pb-5">
                <h5>Revenue & Profit Growth</h5>
              </div>
              <div class="card-body"><AnnualRevenueChart /></div>
            </div>
            <div class="col-lg-4">
              <div class="card-header fw-bold d-flex align-items-center justify-content-between pb-0">
                <h5>Year-To-Date Revenue</h5>
              </div>
              <div class="card-body">
                <YTDRevenueChart />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4" v-else>
      <div class="col-12 text-center mb-4">
        <div class="badge bg-label-primary">Question?</div>
        <h4 class="my-2">You have a question ?</h4>
        <p>If you have any question, you can contact us via the following contact.</p>
      </div>
      <div class="row text-center justify-content-center gap-sm-0 gap-3">
        <div class="col-sm-6">
          <div class="py-3 rounded bg-faq-section text-center">
            <span class="badge bg-label-primary rounded-2 my-3">
              <i class="bx bx-phone bx-sm"></i>
            </span>
            <h4 class="mb-2"><a class="h4" href="tel:+(810)25482568">+ (84) 397 993 001</a></h4>
            <p>We are always happy to help</p>
          </div>
        </div>
        <div class="col-sm-6">
          <div class=" py-3 rounded bg-faq-section text-center">
            <span class="badge bg-label-primary rounded-2 my-3">
              <i class="bx bx-envelope bx-sm"></i>
            </span>
            <h4 class="mb-2">
              <a class="h4" href="mailto:contact.lamodavietnam@gmail.com">contact.lamodavietnam@gmail.com</a>
            </h4>
            <p>Best way to get a quick answer</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- / Content -->
</template>

<script>
import AnnualRevenueChart from "./dashboard/AnnualRevenueChart.vue";
import YTDRevenueChart from "./dashboard/YTDRevenueChart.vue";


  export default {
    name: 'Dashboard',
    components: {
      AnnualRevenueChart,
      YTDRevenueChart
    },
    created() {

    },
    computed: {
      userLogged() {
        if (this.$store.state.auth?.user){
          return this.$store.state.auth.status.loggedIn;
        }
        return false;
      }
    }
  }
</script>

<style scoped>
  .light-style .bg-faq-section {
    background-color: rgba(67,89,113,.05);
  }
</style>